import React from 'react';
import firstBlogImg from '../../../../images/1stBlog.jpg'
import secondBlogImg from '../../../../images/2ndBlog.jpg'
import thirdBlogImg from '../../../../images/3rdBlog.jpg'
import BlogCard from '../BlogCard/BlogCard';

const blogPosts = [
    {
        img: firstBlogImg,
        title: 'A Note About Windows 10 Upgrades',
        content: 'Our clients are constantly asking me about Windows 10 and the upgrade process.'
    },
    {
        img: secondBlogImg,
        title: 'Protect yourself from the WannaCrypt',
        content: 'Microsoft pushes security update to versions windows, provides guidance.'
    },
    {
        img: thirdBlogImg,
        title: 'Microsoft pushes security update to versions windows, provides guidance.',
        content: 'Trying desperately to get all the pictures out of someone’s iCloud account.'
    }
]

const BlogMain = () => {
    return (
        <div className="mt-5 text-center" id="blog">
            <h1 className="text-color"><b>BLOG POSTS</b></h1>
            <p style={{fontSize: '25px'}}>Read our recent blogs to always be updated with our news</p>
            <div className="row d-flex justify-content-center">
                {
                    blogPosts.map(post => <BlogCard post={post}/>)
                }
            </div>
        </div>
    );
};

export default BlogMain;